module.exports = __webpack_public_path__ + "img/mobile-spectrum-Cybersecurity.c9d62db3.png";